import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
export default {
  name: 'RuleHistoryDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      rule: null,
      events: [],
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [10, 20, 50, 100]
      }
    };
  },
  computed: {
    ...mapState('app', ['color']),
    internalOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    tableHeaders() {
      return [{
        sortable: true,
        text: this.$i18n_t('Core.DateTimePicker.dateTime'),
        value: 'timestamp'
      }, {
        sortable: true,
        text: this.$i18n_t('Connectors.Monitoring.rules.table.eventType'),
        value: 'eventType'
      }, {
        sortable: true,
        text: this.$i18n_t('Connectors.Monitoring.rules.table.severity'),
        value: 'severity'
      }, {
        sortable: false,
        text: this.$i18n_t('Connectors.Monitoring.rules.table.details'),
        value: 'details'
      }];
    }
  },
  watch: {
    value(newVal) {
      if (newVal && this.ruleId) {
        this.fetchHistory();
      }
    },
    ruleId(newVal) {
      if (this.value && newVal) {
        this.fetchHistory();
      }
    }
  },
  methods: {
    async fetchHistory() {
      if (!this.ruleId) {
        return;
      }
      this.loading = true;
      this.error = null;
      try {
        const response = await ApiService.getRuleHistory(this.ruleId, 100);
        if (response && response.success) {
          this.rule = response.rule;
          this.events = response.events || [];
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        this.error = error.message || this.$i18n_t('Connectors.Monitoring.rules.history.error');
      } finally {
        this.loading = false;
      }
    },
    getRuleTypeName(ruleType) {
      return this.$i18n_t(`Connectors.Monitoring.rules.types.${ruleType}`);
    },
    getEventColor(eventType, severity) {
      const eventUpper = eventType.toUpperCase();
      if (eventUpper === 'FIRING') {
        const severityUpper = severity ? severity.toUpperCase() : '';
        return severityUpper === 'ERROR' ? 'error' : 'warning';
      }
      if (eventUpper === 'OK') {
        return 'success';
      }
      if (eventUpper === 'MANUALLY_RESOLVED') {
        return 'info';
      }
      return 'grey';
    },
    getSeverityColor(severity) {
      const severityLower = severity.toLowerCase();
      return severityLower === 'error' ? 'danger' : 'warning';
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    formatDetails(event) {
      // extract all fields except timestamp, eventType, severity
      // eslint-disable-next-line no-unused-vars
      const {
        timestamp,
        eventType,
        severity,
        ...details
      } = event;

      // format details as key: value pairs
      return Object.entries(details).filter(([, value]) => value !== null && value !== undefined).map(([key, value]) => `${this.formatFieldName(key)}: ${value}`).join(', ');
    },
    formatFieldName(key) {
      // convert camelCase to Title Case
      return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
    },
    close() {
      this.internalOpen = false;
    }
  }
};